<template>
  <Row>
    <Col span="24">
      <Select
        v-model="searchParams.categoryCode"
        placeholder="请选择类目"
        class="public-inp"
      >
        <Option
          v-for="item in productCategoryAll"
          :value="item.code"
          :key="item.code"
          >{{ item.name }}</Option
        >
      </Select>
      <Select
        v-model="searchParams.brandCode"
        placeholder="请选择品牌"
        class="public-inp"
      >
        <Option v-for="item in brandAll" :value="item.code" :key="item.code">{{
          item.name
        }}</Option>
      </Select>
      <Input
        v-model="searchParams.name"
        placeholder="请输入名称"
        class="public-inp"
      />
      <Input
        v-model="searchParams.spuName"
        placeholder="请输入SPU名称"
        class="public-inp"
      />
      <Button
        type="primary"
        icon="md-search"
        @click="getList()"
        v-access="'spSkuInfo.query'"
        >搜索</Button
      >
      <Button @click="resetList()" v-access="'spSkuInfo.reset'">重置</Button>
    </Col>
    <!--    <Col span="6">
      <Button type="primary" icon="md-add" class="public-fr" @click="addFn()"
        >添加SKU模板</Button
      >
    </Col>-->
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="productSkuSpList.data || []"
      >
        <template slot-scope="{ index }" slot="sort">
          {{ index + 1 }}
        </template>
        <template slot-scope="{ row }" slot="labelNameList">
          <Tag v-for="label in row.labelNameList" :key="label.labelCode">{{
            label.labelName
          }}</Tag>
        </template>
        <template slot-scope="{ row }" slot="name">
          <span href="javascript:;">{{ row.name }}</span>
        </template>

        <template slot-scope="{ row }" slot="status">
          <span>{{ row.status | statusFilter }}</span>
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="productSkuSpList.total"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        show-elevator
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
      />
    </Col>
  </Row>
</template>
<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "商品名称",
    slot: "name",
  },
  {
    title: "商品编码",
    key: "prdCode",
  },
  {
    title: "APP商品名称",
    key: "appShowName",
  },
  {
    title: "SPU名称",
    key: "spuName",
  },
  {
    title: "品牌名称",
    key: "brandName",
  },
  {
    title: "所属分类",
    key: "categoryName",
  },
  {
    title: "属性",
    key: "propertyValueName",
  },
  {
    title: "状态",
    slot: "status",
    width: 100,
  },
];

const searchParams = {
  categoryCode: "",
  status: "",
  brandCode: "",
  spuName: "",
  name: "",
  page: 1,
  pageSize: 10,
};
export default {
  data() {
    return {
      loading: false,
      columns,
      tbList: [],
      total: 0,

      searchParams: JSON.parse(JSON.stringify(searchParams)),
    };
  },
  computed: {
    ...mapGetters("product", {
      productSkuSpList: "getProductSkuSpList",
    }),
    ...mapGetters("category", {
      productCategoryAll: "getProductCategoryAll",
    }),
    ...mapGetters("brand", {
      brandAll: "getBrandAll",
    }),
  },
  filters: {
    //   01：已发布；02：已上架；03：已下架；04：停用；
    statusFilter(status) {
      let sTxt = "";
      switch ("" + status) {
        case "01":
          sTxt = "已发布";
          break;
        case "02":
          sTxt = "已上架";
          break;
        case "03":
          sTxt = "已下架";
          break;
        case "04":
          sTxt = "停用";
          break;
        default:
          break;
      }

      return sTxt;
    },
  },
  created() {
    // 获取初始列表数据
    this.getList();
    // 获取类目数据
    this.$store.dispatch("category/getProductCategoryAll");
    // 获取品牌数据
    this.$store.dispatch("brand/getBrandAll");
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("product/getProductSkuSpList", this.searchParams)
        .then((res) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageNumChange(d) {
      this.searchParams.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.searchParams.pageSize = d;
      // 页码变动触发pageNumChange
      if (this.searchParams.page == 1) {
        this.getList();
      } else {
        this.searchParams.page = 1;
      }
    },
    // 重置
    resetList() {
      this.searchParams = JSON.parse(JSON.stringify(searchParams));
      this.$nextTick(() => {
        this.getList();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/commodity/spSkuInfo.vue